import React, { useEffect } from "react";

const TawkToWidget = () => {

  useEffect(() => {

    var Tawk_API = window.Tawk_API || {};
    var Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.tawk.to/6784a0d249e2fd8dfe068169/1ihf18dnj";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    window.Tawk_API = Tawk_API;

    // hide default bubble
    Tawk_API.onLoad = function () {
      Tawk_API.hideWidget();
    };

    Tawk_API.onChatMinimized = function () {
      Tawk_API.hideWidget();
    };

    return () => {
      document.body.removeChild(script);
    };

  }, []);

  return null;
};

export default TawkToWidget;